import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class UploadDocumentsIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
                <path d="M22.759,14.345c-0.685,0-1.241,0.556-1.241,1.241v4.781c0,0.307-0.12,0.596-0.335,0.811
                    c-0.218,0.218-0.508,0.338-0.815,0.338H3.632c-0.302,0-0.599-0.123-0.811-0.335c-0.218-0.218-0.338-0.508-0.338-0.815v-4.781
                    c0-0.685-0.556-1.241-1.241-1.241S0,14.901,0,15.586v4.781c0,0.968,0.377,1.88,1.064,2.57c0.676,0.674,1.612,1.062,2.568,1.062
                    h16.736c0.968,0,1.88-0.377,2.57-1.065C23.623,22.247,24,21.335,24,20.367v-4.781C24,14.901,23.444,14.345,22.759,14.345z"/>
                <path d="M6.9,8.096l3.858-3.858v11.349c0,0.685,0.556,1.241,1.241,1.241s1.241-0.556,1.241-1.241V4.237L17.1,8.096
                    c0.242,0.242,0.559,0.364,0.878,0.364c0.318,0,0.635-0.121,0.878-0.364c0.485-0.485,0.485-1.27,0-1.755l-5.977-5.977
                    c-0.114-0.114-0.252-0.205-0.403-0.268c-0.303-0.126-0.645-0.126-0.949,0c-0.152,0.063-0.289,0.153-0.403,0.268L5.145,6.34
                    c-0.485,0.485-0.485,1.27,0,1.755S6.415,8.581,6.9,8.096z"/>
            </g>
        </SvgIcon>;
    }
}
